export const mockRegistriaResponseUser = {
  id: '1234567',
  success: true,
  message: 'updated user',
  snippet_url: 'https://www.google.com',
};
